import * as React from "react";
import Slider from "react-slick";
import { DropdownList } from "react-widgets";
import api from "../../api";
import { htmlDecode, setDashboardSearchData } from "../../core";
import { Project, PropertyDetails, Unit } from "../../core/api/models/project";
import moment from "moment";
import { LeadRequirement } from "../../core/api/models/requirement";
import { decodeHtmlEntities } from "../../utils/common";
import { FurnishingHeadAttributeKeys, Property } from "../../core/api/models/property";
// Property Details PopUp
import  MapPreviewImage from '../../assets/images/map-preview.png'
import { useDispatch } from "react-redux";

const PropertyOverview: React.FunctionComponent<{
  project?: Property;
  onClose?: ()=> void
}> = (props) => {
  const [mainSlider, setMainSlider] = React.useState<any>(null);
  const [thumbSlider, setThumbSlider] = React.useState<any>(null);
  const [isMapEnabled, setIsMapEnabled] = React.useState<boolean>(false);
  const dispatch = useDispatch();


  const settings = {
    className: "property-slider mb-3 pb-1",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const thumbSettings = {
    className: "property-thumb-slider",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    focusOnSelect: true,
  };

  const openDeveloperTab = (e: React.MouseEvent<HTMLSpanElement>, developerId :string) => {
    e.stopPropagation();
    if(props.onClose){
     props.onClose()
    }
    window.scrollTo(0, 0)
    dispatch(
      setDashboardSearchData({
        selectedDevelopers: [developerId],
        selectedTab: 'Developers',
      })
    );
  }

  return (
    <>
      <div className="pt-4">
        <div className="container-fluid">
          <div className="row mb-5">
            <div className="col-md-6 col-12 pl-0 pr-5">
              <Slider {...settings} asNavFor={thumbSlider} ref={(slider) => setMainSlider(slider)}>
                <img
                  src={props.project?.propertyCoverImage}
                  alt={props.project?.projectDetails.projectName}
                  className="img-cover rounded"
                />
              </Slider>
              {/* <Slider
                {...thumbSettings}
                asNavFor={mainSlider}
                ref={(slider) => setThumbSlider(slider)}
              >
               
                {props.project?.resImages?.map((img) => {
                  return (
                    <div style={{ width: "88px" }}>
                      <img
                        src={`https://cf-cdn.cityinfoservices.com/public/uploads/project/images/small/${img.projectImageName}`}
                        alt={img.projectImageAltTag}
                        className="img-cover mr-2 w-100"
                      />
                    </div>
                  );
                })}
              </Slider> */}
              <div className="mt-4 pt-3">
                {/* <h5 className="font-weight-semibold mb-2">About Property</h5>

                <div
                // dangerouslySetInnerHTML={{
                //   __html: props.project?.projectDescription || "",
                // }}
                >
                  {props.project?.projectDetails?.projectDescription}
                </div> */}

                <h5 className="font-weight-semibold my-3">Amenities</h5>
                <div className="row">
                  {props.project?.amenities?.map((up) => (
                    <div className="col-md-4 col-6 font-sm d-flex align-items-center mb-4">
                      <div className="text-center" style={{ width: "34px" }}>
                        <img
                          src={up.attrOptionImage}
                          className="icon-security-person"
                          alt={up.attrOptName}
                          width="25"
                          height="25"
                        />
                      </div>
                      <span className="pl-2 ml-1"> {up.attrOptName}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 px-0">
              <div className="d-flex align-items-center">
                <h2 className="flex-fill pr-3 font-xxl mb-2 font-weight-semibold">
                  {props.project?.propertyName}
                </h2>
              </div>
              {!!props.project?.projectDetails?.projectBuilderName?.developer && <div className="d-flex font-sm align-items-center mb-2">
                <span role='button' className="text-gray-800" onClick={(e)=>openDeveloperTab(e, props.project?.projectDetails?.projectBuilderName?.developer || '')}>
                  by {props.project?.projectDetails?.projectBuilderName?.developer}
                </span>
                {/* <span className="separator"></span> */}
              </div>}
              <div className="d-flex font-sm align-items-center mb-2 text-gray-800">
                <span className="text-gray-500 mr-1">Property Type:</span> {props.project?.propertyTypeName}
              </div>
              <div className="d-flex font-sm align-items-center mb-2 text-gray-800 pb-1">
                <i className="icon-location-filled mr-2 text-gray-500"></i>
                {htmlDecode(props.project?.propertyAddress1!)}
              </div>

              {props.project?.priceOnReq?.toLowerCase() === 'yes' ?
                <>
                    <div className="border-bottom pb-2 mb-4">
                      <h3 className="mb-0">Price On Request</h3>
                    </div>
                </>
                :
                <>
                  {props.project?.pricePerSqft && (
                    <div className="border-bottom pb-2 mb-4">
                      <h3 className="mb-0">₹ {props.project?.pricePerSqft}</h3>
                      <div className="font-sm text-gray-500">Per Sq. Ft</div>
                    </div>
                  )}
                </>
              }

              <div className="row">
                {props.project?.attributes?.map((attr) => {
                  if (attr?.attrKey !== "amenities-property") {
                    if (
                      props?.project?.propertyTypeKey === "business-center-co-working-space" &&
                      FurnishingHeadAttributeKeys?.includes(attr?.attrKey)
                    ) {
                      return;
                    }
                    return (
                      attr.attrOptionValue && (
                        <div className="col-md-4 col-6 mb-3">
                          <div className="border-bottom py-3">
                            <div className="font-sm text-gray-500 mb-1">{attr.attrName}</div>
                            <div className="mb-0 font-sm font-weight-semibold text-gray-800">
                              {attr.attrOptionValue}
                            </div>
                          </div>
                        </div>
                      )
                    );
                  }
                })}
              </div>
            </div>
          </div>
          {props.project?.propertyFloorImage && (
            <>
              <h5 className="font-weight-semibold my-3">Floor Plan</h5>
              <div>
                <img
                  src={props.project?.propertyFloorImage}
                  className="icon-security-person"
                  alt={props.project?.propertyName}
                  width="626"
                />
              </div>
            </>
          )}
          <div className="row border-top pt-5">
            <div className="col-12 px-0">
              <h2 className="mb-4">Location Map</h2>
            </div>
            {isMapEnabled ? (
              <iframe
                title={props.project?.propertyAddress1}
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDswP272vF5WZVy9n8lBai1df9bbuvzblI&q=${props.project?.propertyLatitude},${props.project?.propertyLongitude}`}
                width="626"
                height="315"
                loading="lazy"
                className="border-0"
              ></iframe>
            ) : (
              <div
              className="d-flex justify-content-center align-items-center position-relative "
              style={{ width: "626px", height: "315px" }}
            >
              <img
                src={MapPreviewImage}
                alt="mapImage"
                width="100%"
                height="100%"
                style={{ filter: "blur(5px)" }}
              />
              <button
                className="btn btn-primary  font-normal font-weight-bold position-absolute "
                onClick={() => setIsMapEnabled(true)}
              >
                View Map
              </button>
            </div>
            )}
            <div className="col-12 px-0 font-sm">
              <div className="mb-1">{props.project?.city?.cityName}</div>
              <div>
                <i className="icon-location-filled mr-2 text-gray-500"></i>
                {htmlDecode(props.project?.propertyAddress1!)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyOverview;
